import directive from './bsl-directive';

export default (Vue => {
    Vue.directive('body-scroll-lock', directive);
    Vue.directive('bsl', directive);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/v-body-scroll-lock/dist/directives/v-body-scroll-lock.js
// module id = null
// module chunks = 